var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9938 16L27.3736 7.62021C27.7713 7.22321 27.995 6.68448 27.9955 6.12254C27.996 5.5606 27.7732 5.02148 27.3762 4.62378C26.9792 4.22607 26.4405 4.00237 25.8786 4.00187C25.3166 4.00138 24.7775 4.22413 24.3798 4.62113L16 13.0009L7.62021 4.62113C7.22251 4.22343 6.68311 4 6.12067 4C5.55823 4 5.01883 4.22343 4.62113 4.62113C4.22343 5.01883 4 5.55823 4 6.12067C4 6.68311 4.22343 7.22251 4.62113 7.62021L13.0009 16L4.62113 24.3798C4.22343 24.7775 4 25.3169 4 25.8793C4 26.4418 4.22343 26.9812 4.62113 27.3789C5.01883 27.7766 5.55823 28 6.12067 28C6.68311 28 7.22251 27.7766 7.62021 27.3789L16 18.9991L24.3798 27.3789C24.7775 27.7766 25.3169 28 25.8793 28C26.4418 28 26.9812 27.7766 27.3789 27.3789C27.7766 26.9812 28 26.4418 28 25.8793C28 25.3169 27.7766 24.7775 27.3789 24.3798L18.9938 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.f26ebdbc8c2eadc864b819958615dc1e.svg";
export { ForwardRef as ReactComponent };